export { DiamondHandsTotalStats } from '~features/diamondHands/DiamondHandsOverview/DiamondHandsTotalStats';
